<template lang="pug">
v-app
  v-app-bar(app color="white" flat dark)
    v-app-bar-nav-icon.d-lg-none(@click.stop="drawer = !drawer" color="primary")
    v-spacer
    v-menu(offset-y v-if="myMemberships && myMemberships.length > 1")
      template(v-slot:activator="{ on, attrs }")
        v-btn(v-bind="attrs" v-on="on" color="primary" text rounded)
          v-icon.mr-1 mdi-domain
          span(v-if="membershipContext") {{ membershipContext.business_name }}
          v-icon mdi-triangle-small-down
      v-list
        template(v-for="membership in myMemberships")
          v-list-item(v-if="membershipContext && membership.id !== membershipContext.id" :key="membership.id" @click="setMembershipContext(membership)")
            v-list-item-title {{ membership.business_name }}
    v-menu(offset-y)
      template(v-slot:activator="{ on, attrs }")
        v-btn(v-bind="attrs" v-on="on" color="primary" text rounded)
          v-icon mdi-account
          span(v-if="user") {{user.first_name}}
          v-icon mdi-triangle-small-down
      v-list
        v-list-item(@click="passwordDialog = true")
          v-list-item-icon
            v-icon mdi-key-variant
          v-list-item-title Cambiar contraseña
        v-list-item(@click="onExit")
          v-list-item-icon
            v-icon mdi-logout
          v-list-item-title Salir
  v-navigation-drawer(v-model="drawer" app elevation=10 width="255px" color="primary" dark)
    .text-right.mt-3.mr-3.d-lg-none
      v-app-bar-nav-icon(@click.stop="drawer = !drawer" color="primary")
    v-img.my-md-12(src="../assets/img/brand/logotipo.png" width=200 style="margin: auto;" @click="$router.push('/')")
    v-list(nav dense variant="primary" expand)
      template(v-for="(item, i) in visibleMenuItems")
        //- Link Simple
        template(v-if="!item.divider")
          v-list-item(:key="i" :disabled="item.disabled" @click="onNavClick(item)" :to="item.to" active-class="v-list-item--active" :id="item.id")
            v-list-item-icon.mr-1
              v-icon {{item.icon}}
              v-icon.ml-2 {{item.numberIcon}}
            v-list-item-content
              v-list-item-title(v-text="item.text")
        //- Divider
        template(v-else)
          h5.mt-md-6.mb-md-2.mx-2(style="font-weight: 700; color: white;") {{item.text}}
  v-main
    slot(style="height: 100%")

  v-fab-transition(v-if="wizardIsActive")
    v-btn.mb-16(fab color="white" dark fixed bottom right @click="globalEmitter(WIZARD_STEPS_EVENTS.OPEN_LAST_WIZARD_STEP)" width="90" height="90")
      v-img.ma-2(src="/img/wizard_fab.png" width="64" contain)

  v-dialog(v-model="passwordDialog" max-width="420")
    v-card
      v-card-title.text-h6 Cambiar contraseña
      v-card-text
        v-text-field(v-model="pwForm.current_password" label="Contraseña actual" type="password" outlined dense)
        v-text-field(v-model="pwForm.new_password" label="Contraseña nueva" type="password" outlined dense hint="Al menos 8 caracteres" persistent-hint)
        v-text-field(v-model="pwForm.confirm" label="Repetir contraseña nueva" type="password" outlined dense)
        .red--text.text-body-2(v-if="pwError") {{pwError}}
      v-card-actions
        v-spacer
        v-btn(text @click="passwordDialog = false") Cancelar
        v-btn(color="primary" :loading="pwLoading" @click="submitPassword") Guardar
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { WIZARD_ELEMENTS_ID, WIZARD_STEPS_EVENTS } from '../constants'
import { globalEmitter } from '@/utils/eventBus'

export default {
  data() {
    return {
      WIZARD_STEPS_EVENTS,
      businesses: [],
      drawer: true,
      passwordDialog: false,
      pwLoading: false,
      pwError: '',
      pwForm: { current_password: '', new_password: '', confirm: '' },
      menuItems: [
        {
          text: 'Inicio',
          to: '/',
          icon: 'mdi-home',
        },
        {
          text: 'Para aprender',
          to: '/aprender',
          icon: 'mdi-notebook-edit-outline'
        },
        {
          divider: true,
          text: '1. Configura tu negocio'
        },
        {
          text: 'Clientes',
          to: '/clientes',
          icon: 'mdi-account-group',
          numberIcon: 'mdi-numeric-1',
          id: WIZARD_ELEMENTS_ID.NAV_CLIENTS,
          emit: WIZARD_STEPS_EVENTS.NAV_TO_CLIENTS
        },
        {
          text: 'Productos Base',
          to: '/productos-base',
          icon: 'mdi-shape-outline',
          advancedOnly: true,
        },
        {
          text: 'Productos',
          simpleText: 'Productos y servicios',
          to: '/productos',
          icon: 'mdi-package-variant-closed',
          numberIcon: 'mdi-numeric-2',
          id: WIZARD_ELEMENTS_ID.NAV_PRODUCTS
        },
        {
          text: 'Capacidad de Producción',
          to: '/capacidad-produccion',
          icon: 'mdi-chart-areaspline',
          numberIcon: 'mdi-numeric-3',
          id: WIZARD_ELEMENTS_ID.NAV_PRODUCTION_CAPACITY,
          advancedOnly: true,
        },
        {
          divider: true,
          text: '2. Analiza tu negocio'
        },
        {
          text: 'Proyección comercial',
          to: '/proyeccion-comercial',
          icon: 'mdi-star-plus',
          numberIcon: 'mdi-numeric-1',
          id: WIZARD_ELEMENTS_ID.NAV_COMMERCIAL_PROJECTION
        },
        {
          divider: true,
          text: '3. Controla tu negocio'
        },
        {
          text: 'Plan de Ventas',
          to: '/planes?tab=0',
          icon: 'mdi-cart-outline',
          numberIcon: 'mdi-numeric-1',
        },
        {
          text: 'Plan de costos',
          to: '/planes?tab=1',
          icon: 'mdi-cash-multiple',
          numberIcon: 'mdi-numeric-2',
        },
        {
          text: 'Seguimiento',
          to: '/seguimiento',
          icon: 'mdi-radar',
          numberIcon: 'mdi-numeric-3',
        },
        {
          divider: true,
          text: 'Ajustes',
        },
        {
          text: 'Configuración',
          to: '/negocio',
          icon: 'mdi-cog-outline',
        },
      ]
    }
  },
  methods: {
    globalEmitter,
    ...mapActions('auth', ['logout', 'changePassword']),
    ...mapActions('business', ['listBusinesses']),
    async submitPassword() {
      this.pwError = ''
      if (this.pwForm.new_password !== this.pwForm.confirm) {
        this.pwError = 'Las contraseñas nuevas no coinciden.'
        return
      }
      if ((this.pwForm.new_password || '').length < 8) {
        this.pwError = 'La nueva contraseña debe tener al menos 8 caracteres.'
        return
      }
      this.pwLoading = true
      const res = await this.changePassword({
        current_password: this.pwForm.current_password,
        new_password: this.pwForm.new_password,
      })
      this.pwLoading = false
      if (res && res.status === 200) {
        this.passwordDialog = false
        this.pwForm = { current_password: '', new_password: '', confirm: '' }
        this.$toast && this.$toast.success('Contraseña actualizada')
      } else {
        this.pwError = (res && res.data && res.data.detail) || 'No se pudo cambiar la contraseña.'
      }
    },
    ...mapActions('app_config', ['setCurrentBusiness']),
    ...mapActions('app', ['setMembershipContext']),
    onExit() {
      this.logout()
      this.$router.push('/login')
    },
    onNavClick(item) {
      if (item.emit) {
        globalEmitter(item.emit)
      }

      if (item.to.split('?')[0] === this.$route.path) {
        return
      }
      this.$router.push(item.to)
    }
  },
  computed: {
    ...mapGetters('auth', ['user']),
    ...mapGetters('app', ['myMemberships']),
    ...mapGetters('app', ['membershipContext', 'wizardIsActive']),
    ...mapGetters('app_config', ['currentBusiness']),
    isStaff() {
      return !!(this.user && (this.user.is_staff || this.user.is_superuser))
    },
    isSimpleMode() {
      return this.currentBusiness && this.currentBusiness.catalog_mode === 'simplificado'
    },
    modeMenuItems() {
      // En modo simplificado se ocultan los ítems avanzados (Productos Base,
      // Capacidad de Producción) y "Productos" pasa a "Productos y servicios".
      if (!this.isSimpleMode) {
        return this.menuItems
      }
      return this.menuItems
        .filter(item => !item.advancedOnly)
        .map(item => item.simpleText ? { ...item, text: item.simpleText } : item)
    },
    visibleMenuItems() {
      if (!this.isStaff) {
        return this.modeMenuItems
      }
      return [
        ...this.modeMenuItems,
        { divider: true, text: 'Year2Day' },
        { text: 'Administración Y2D', to: '/administracion', icon: 'mdi-shield-account' },
      ]
    },
  },
  async created() {
    const response = await this.listBusinesses({ params: { page_size: 100 } })

    if (response.status === 200) {
      this.businesses = response.data.results
    }
  }
}
</script>

<style lang="scss">
.v-list-item--active {
  background-color: white !important;
  .v-list-item__title {
    color: #5575DF !important;
  }
  .v-icon {
    color: #5575DF !important;
  }
}
</style>